module.exports = __webpack_public_path__ + "static/fusion03-58412edb9923d0b464d3869c69c5768c.png";